import { iQCRule } from "@sdk/agent-quality-control/qc-rule-groups.models";
import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const AddEditQCRuleModal = React.lazy(() => import("./add-edit-qc-rule.modal"));

const AddEditQCRule: iModalProps<
  typeof AddEditQCRuleModal,
  {
    ruleGroupId?: string;
    ruleId?: string;
    initialRule?: iQCRule;
    onRuleSaved?: (rule: iQCRule) => void;
    onCompleted?: () => void;
  }
> = {
  name: "add-edit-qc-rule",
  component: GenerateModalWithSuspense(AddEditQCRuleModal),
};

export default AddEditQCRule;
